import { parseClassnames } from '@incloodsolutions/react-toolkit';

interface IBrandWordmarkComponentProps {
	/** Below the `sm` breakpoint (phones), shows the short mark "w." instead of the whole word. */
	hasShortMarkOnMobile?: boolean;
	/** Shows the short mark "w." at every width. */
	isShortMark?: boolean;
	/** The text size, such as `text-xl`. Defaults to `text-2xl`. Colour and font come from the page around it. */
	className?: string;
}

/**
 * The official Workinance brand as text: "workinance." with a blue full stop, or just "w." for small spaces.
 * Every app and the landing site use this one component, so the brand cannot drift between them. The same
 * wordmark as an image (logo files, favicons, app icons) is in packages/shared/brand, the one place every app reads
 * its brand images from.
 *
 * It takes its font and colour from where it sits, so put it in a page set in the app font (Schibsted
 * Grotesk). Wrap it in a link yourself where it should go home, and give the link an `aria-label`.
 */
export function BrandWordmarkComponent({
	hasShortMarkOnMobile = false,
	isShortMark = false,
	className = 'text-2xl',
}: IBrandWordmarkComponentProps) {
	return (
		<span
			role="img"
			aria-label="Workinance"
			className={parseClassnames(
				'leading-none font-extrabold tracking-tighter',
				className,
			)}
		>
			<span aria-hidden="true">
				w
				{/* The rest of the word is the only part the short mark leaves out. */}
				<span
					className={parseClassnames({
						hidden: isShortMark,
						'max-sm:hidden': !isShortMark && hasShortMarkOnMobile,
					})}
				>
					orkinance
				</span>
				<span className="text-brand">.</span>
			</span>
		</span>
	);
}
